'use client';

import { createContext } from 'react';

import type { MenuGroupContextInterface } from '../types/menu-group.types';

export const MenuGroupContext = createContext<MenuGroupContextInterface>({});

MenuGroupContext.displayName = 'Menu.Group.Context';
